import { render, staticRenderFns } from "./catalog-filter-drawer.vue?vue&type=template&id=c6f266ea&scoped=true"
import script from "./catalog-filter-drawer.vue?vue&type=script&lang=js"
export * from "./catalog-filter-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f266ea",
  null
  
)

export default component.exports